export default __webpack_public_path__ + "static/media/background-image.912a1f76.png";